export const ROUTES = {
  APP: "/",
  SIGN_IN: "/sign-in",
  CREATE_PASSWORD: "/create-password",
  FORGOT_PASSWORD: "/forgot-password",
  NEED_HELP: "/need-help",
  SEARCH: "/search",
  PATIENT_STATS: "/patient/:patientID",
  PATIENT_DETAILS_ALLERGIES: "/patient/:patientID/allergies",
  PATIENT_DETAILS_MEDICATIONS: "/patient/:patientID/medications",
  PATIENT_DETAILS_IMMUNIZATIONS: "/patient/:patientID/immunizations",
  PATIENT_DETAILS_APPOINTMENTS: "/patient/:patientID/appointments",
  PATIENT_DETAILS_DEMOGRAPHICS: "/patient/:patientID/demographics",
  PATIENT_DETAILS_DOCUMENTS: "/patient/:patientID/documents",
  PATIENT_DETAILS_DICOM_STUDIES: "/patient/:patientID/dicom-studies",
  PATIENT_DETAILS_ENCOUNTERS: "/patient/:patientID/encounters",

  PATIENT_DETAILS_ENCOUNTERS_HISTORY_REPORT:
    "/patient/:patientID/encounters/:encounterID/history-report",
  PATIENT_DETAILS_ENCOUNTERS_LABS_REPORT:
    "/patient/:patientID/encounters/:encounterID/labs-procedures",

  PATIENT_DETAILS_ENCOUNTERS_LABS_REPORT_LAB:
    "/patient/:patientID/encounters/:encounterID/labs-procedures",

  PATIENT_DETAILS_ENCOUNTERS_LABS_REPORT_DETAILS:
    "/patient/:patientID/encounters/:encounterID/labs-procedures/:labResultID/details",
  PATIENT_DETAILS_ENCOUNTERS_LABS_REPORT_PROCEDURE_DETAILS:
    "/patient/:patientID/encounters/:encounterID/labs-procedures/:procedureResultID/procedure-details",

  PATIENT_DETAILS_ENCOUNTERS_BILLING_REPORT:
    "/patient/:patientID/encounters/:encounterID/billing-information",
  PATIENT_DETAILS_ENCOUNTERS_SCANNED_DOCS:
    "/patient/:patientID/encounters/:encounterID/scanned-documents",

  PATIENT_DETAILS_FLOWSHEETS: "/patient/:patientID/flowsheets",
  PATIENT_DETAILS_FLOWSHEET_DETAILS:
    "/patient/:patientID/flowsheets/:flowsheetID",
  PATIENT_DETAILS_INSURANCE: "/patient/:patientID/insurance",
  PATIENT_DETAILS_ORDERS_PROCEDURES: "/patient/:patientID/orders-procedures",
  PATIENT_DETAILS_ORDERS_PROCEDURES_DETAILS:
    "/patient/:patientID/orders-procedures/:orderID",
  PATIENT_DETAILS_PHYSICIAN_CARE_TEAM:
    "/patient/:patientID/physician-care-team",
  PATIENT_DETAILS_RESULTS: "/patient/:patientID/results",
  PATIENT_DETAILS_RESULT_DETAILS: "/patient/:patientID/results/:resultID",
  PATIENT_DETAILS_SUMMARY: "/patient/:patientID/summary",
  PATIENT_DETAILS_VITALS: "/patient/:patientID/vitals",
  PATIENT_DETAILS_ROI_REPORTS: "/patient/:patientID/roi-reports",
  PATIENT_DETAILS_ROI_REQUEST_VIEW:
    "/patient/:patientID/roi-reports/:requestID",
};

// Medications
// Immunizations
// -------------
// Appointments
// Demographics
// Documents
// DICOM Studies
// Encounters
// Flowsheets
// Insurance
// Orders & Procedures
// Physician Care Team
// Results
// Summary
// Vitals
